import { render, staticRenderFns } from "./PortfolioWriteLink.vue?vue&type=template&id=65d0d471&scoped=true"
import script from "./PortfolioWriteLink.vue?vue&type=script&lang=js"
export * from "./PortfolioWriteLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0d471",
  null
  
)

export default component.exports